(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-about-audiences"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    const setup = (root) => {
      if (root.dataset.fpAudBound) return;
      root.dataset.fpAudBound = 'true';

      const rows = [...root.querySelectorAll('.fp-aud__row')];
      if (!rows.length) return;

      const open = (n) => rows.forEach((row, i) => row.classList.toggle('is-open', i === n));

      rows.forEach((row, n) => {
        row.addEventListener('pointerenter', () => { if (fine.matches) open(n); });
      });

      // Touch: the row crossing the middle of the screen opens. Checked on
      // every change, not once at load.
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (fine.matches) return;
          entries.forEach((entry) => entry.isIntersecting && open(rows.indexOf(entry.target)));
        }, { rootMargin: '-45% 0px -45% 0px' });
        rows.forEach((row) => observer.observe(row));
      }
    };

    const init = () => document.querySelectorAll('[data-fp-aud]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-about-company"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setup = (root) => {
      if (root.dataset.fpCoBound) return;
      root.dataset.fpCoBound = 'true';
      if (reduced.matches || !('IntersectionObserver' in window)) return;
      root.classList.add('is-armed');
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        root.classList.add('is-in');
        observer.disconnect();
      }, { threshold: 0.3 });
      observer.observe(root);
    };
    const init = () => document.querySelectorAll('[data-fp-co]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-about-mission"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Wrap each word of an element's text in a span, keeping inline markup.
    const splitWords = (root, className, start = 0) => {
      let index = start;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        if (!node.textContent.trim()) return;
        const fragment = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
            return;
          }
          const span = document.createElement('span');
          span.className = className;
          span.style.setProperty('--w', index++);
          span.textContent = part;
          fragment.appendChild(span);
        });
        node.replaceWith(fragment);
      });
      return index;
    };

    const setup = (root) => {
      if (root.dataset.fpMissionBound) return;
      root.dataset.fpMissionBound = 'true';

      const heading = root.querySelector('[data-fp-mission-heading]');
      const statement = root.querySelector('[data-fp-mission-statement]');
      const beliefs = [...root.querySelectorAll('.fp-mission__belief')];

      if (reduced.matches || !('IntersectionObserver' in window)) {
        beliefs.forEach((belief) => belief.classList.add('is-in'));
        return;
      }

      if (heading) {
        const words = splitWords(heading, 'fp-mission__word');
        root.style.setProperty('--underline-delay', `${words * 70 + 300}ms`);
        root.style.setProperty('--road-delay', `${words * 70 + 500}ms`);
      }

      let lit = [];
      if (statement) {
        splitWords(statement, 'fp-mission__lit');
        lit = [...statement.querySelectorAll('.fp-mission__lit')];
      }

      root.classList.add('is-armed');
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-playing')));

      // Light the statement as it is read: words switch on as it scrolls up
      // through the middle of the screen.
      let frame = 0;
      const light = () => {
        frame = 0;
        if (!statement) return;
        const rect = statement.getBoundingClientRect();
        const view = window.innerHeight;
        const progress = Math.min(1, Math.max(0, (view * 0.78 - rect.top) / (rect.height + view * 0.28)));
        const count = Math.round(progress * lit.length);
        lit.forEach((word, n) => word.classList.toggle('is-on', n < count));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(light); };
      // Horizon scrolls .page-wrapper on desktop, not the window, so listen in capture.
      document.addEventListener('scroll', schedule, { passive: true, capture: true });
      window.addEventListener('resize', schedule, { passive: true });
      light();

      const reveal = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          reveal.unobserve(entry.target);
        });
      }, { threshold: 0.3 });
      beliefs.forEach((belief) => reveal.observe(belief));
    };

    const init = () => document.querySelectorAll('[data-fp-mission]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-article"]) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.fpArticleBound) return;
      root.dataset.fpArticleBound = 'true';

      const body = root.querySelector('[data-fp-article-body]');
      const bar = document.querySelector('.fp-article__progress');
      const toc = root.querySelector('.fp-article__toc');
      const list = root.querySelector('[data-fp-toc]');
      if (!body) return;

      // Contents list from the article's H2s.
      const headings = [...body.querySelectorAll('h2')];
      const links = [];
      headings.forEach((heading, n) => {
        if (!heading.id) {
          heading.id = `${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'section'}-${n + 1}`;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list?.appendChild(item);
        links.push(link);
      });
      if (toc && headings.length > 1) toc.hidden = false;

      // H2s draw their orange underline as they arrive; the current one lights up in the contents.
      if ('IntersectionObserver' in window) {
        const arrive = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            arrive.unobserve(entry.target);
          });
        }, { threshold: 0.6 });
        const current = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const n = headings.indexOf(entry.target);
            links.forEach((link, i) => link.classList.toggle('is-active', i === n));
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        headings.forEach((heading) => { arrive.observe(heading); current.observe(heading); });
      } else {
        headings.forEach((heading) => heading.classList.add('is-revealed'));
      }

      // Reading progress. Horizon scrolls .page-wrapper on desktop, so listen in capture.
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!bar) return;
        const rect = body.getBoundingClientRect();
        const view = window.innerHeight;
        const read = Math.min(1, Math.max(0, (view * 0.35 - rect.top) / Math.max(1, rect.height - view * 0.35)));
        bar.style.setProperty('--read', read.toFixed(4));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      document.addEventListener('scroll', schedule, { passive: true, capture: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();

      // Copy link
      root.querySelectorAll('[data-fp-copy]').forEach((button) => {
        button.addEventListener('click', async () => {
          const label = button.querySelector('[data-fp-copy-label]');
          try {
            await navigator.clipboard.writeText(button.dataset.fpCopy);
            button.classList.add('is-done');
            if (label) label.textContent = 'Copied';
            setTimeout(() => {
              button.classList.remove('is-done');
              if (label) label.textContent = 'Copy link';
            }, 1800);
          } catch (error) {
            window.prompt('Copy this link', button.dataset.fpCopy);
          }
        });
      });
    };

    const init = () => document.querySelectorAll('[data-fp-article]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    const setup = (root) => {
      if (root.dataset.fpBlogBound) return;
      root.dataset.fpBlogBound = 'true';

      const items = [...root.querySelectorAll('.fp-blog__item')];
      const chips = [...root.querySelectorAll('.fp-blog__chip')];
      const empty = root.querySelector('.fp-blog__empty');

      // Cards rise in as the grid arrives, staggered in reading order.
      if (!reduced.matches && 'IntersectionObserver' in window) {
        root.classList.add('is-armed');
        let batch = 0;
        let batchTimer = 0;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--n', batch++);
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
          clearTimeout(batchTimer);
          batchTimer = setTimeout(() => { batch = 0; }, 200);
        }, { threshold: 0.15 });
        items.forEach((item) => observer.observe(item));
        // Safety net: never leave a card invisible if the observer never reports.
        setTimeout(() => items.forEach((item) => item.classList.add('is-in')), 4000);
      } else {
        items.forEach((item) => item.classList.add('is-in'));
      }

      // Topic filters: the cards that no longer match shrink away.
      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const key = chip.dataset.fpFilter;
          chips.forEach((c) => {
            c.classList.toggle('is-active', c === chip);
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
          let shown = 0;
          items.forEach((item) => {
            const match = key === 'all' || item.dataset.fpTopics.split(' ').includes(key);
            if (match) shown++;
            if (match) {
              item.classList.remove('is-hidden');
              requestAnimationFrame(() => item.classList.remove('is-leaving'));
            } else if (!item.classList.contains('is-hidden')) {
              item.classList.add('is-leaving');
              setTimeout(() => { if (item.classList.contains('is-leaving')) item.classList.add('is-hidden'); }, reduced.matches ? 0 : 320);
            }
          });
          if (empty) empty.hidden = shown > 0;
        });
      });

      // The featured card leans gently towards the cursor.
      const featured = root.querySelector('[data-fp-tilt]');
      if (featured && !reduced.matches) {
        featured.addEventListener('pointermove', (event) => {
          if (!fine.matches) return;
          const rect = featured.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - 0.5;
          const y = (event.clientY - rect.top) / rect.height - 0.5;
          featured.style.setProperty('--ty', `${x * 4}deg`);
          featured.style.setProperty('--tx', `${-y * 4}deg`);
        });
        featured.addEventListener('pointerleave', () => {
          featured.style.setProperty('--ty', '0deg');
          featured.style.setProperty('--tx', '0deg');
        });
      }
    };

    const init = () => document.querySelectorAll('[data-fp-blog]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Hovering a card that has already played runs its demo again from the start.
    const bind = () => {
      document.querySelectorAll('.fp-builder__tile').forEach((tile) => {
        if (tile.dataset.fpDemoBound) return;
        tile.dataset.fpDemoBound = 'true';
        tile.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !tile.classList.contains('is-revealed')) return;
          tile.classList.add('is-replaying');
          void tile.offsetWidth;
          tile.classList.remove('is-replaying');
        });
      });
    };
    bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = () => document.querySelectorAll('.fp-cards--widgets .fp-card');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    const bind = () => {
      cards().forEach((card) => {
        if (card.dataset.fpWidgetBound) return;
        card.dataset.fpWidgetBound = 'true';

        card.addEventListener('pointermove', (event) => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--mx', `${event.clientX - rect.left}px`);
          card.style.setProperty('--my', `${event.clientY - rect.top}px`);
        });
        card.addEventListener('pointerenter', () => canHover.matches && card.classList.add('is-live'));
        card.addEventListener('pointerleave', () => canHover.matches && card.classList.remove('is-live'));
        card.addEventListener('focusin', () => card.classList.add('is-live'));
        card.addEventListener('focusout', () => card.classList.remove('is-live'));
      });

      // Touch screens have no hover, so each screen plays as it scrolls into
      // view. Checked on every change, not once at load.
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => entries.forEach((entry) => {
            if (!canHover.matches) entry.target.classList.toggle('is-live', entry.isIntersecting);
          }),
          { threshold: 0.6 }
        );
        cards().forEach((card) => observer.observe(card));
      }
    };

    bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  (() => {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const point = (card, event, x, y) => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty(x, `${event.clientX - rect.left}px`);
      card.style.setProperty(y, `${event.clientY - rect.top}px`);
    };

    const bind = () => {
      const cards = document.querySelectorAll('.fp-cards--motion .fp-card');
      cards.forEach((card) => {
        if (card.dataset.fpInkBound) return;
        card.dataset.fpInkBound = 'true';

        // The grey wash grows from where the pointer enters and retreats to where it leaves.
        card.addEventListener('pointerenter', (event) => {
          if (!canHover.matches) return;
          point(card, event, '--ox', '--oy');
          point(card, event, '--gx', '--gy');
          card.classList.add('is-live');
        });
        card.addEventListener('pointermove', (event) => canHover.matches && point(card, event, '--gx', '--gy'));
        card.addEventListener('pointerleave', (event) => {
          if (!canHover.matches) return;
          point(card, event, '--ox', '--oy');
          card.classList.remove('is-live');
        });
        card.addEventListener('focusin', () => card.classList.add('is-live'));
        card.addEventListener('focusout', () => card.classList.remove('is-live'));
      });

      // Touch screens: the card crossing the middle of the screen plays.
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => entries.forEach((entry) => {
            if (!canHover.matches) entry.target.classList.toggle('is-live', entry.isIntersecting);
          }),
          { rootMargin: '-40% 0px -40% 0px' }
        );
        cards.forEach((card) => observer.observe(card));
      }
    };

    bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  (() => {
    // "Who we help" scenes play on hover. Touch has no hover, so the card
    // crossing the middle of the screen plays instead, one at a time.
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const bind = () => {
      if (!('IntersectionObserver' in window)) return;
      const cards = [...document.querySelectorAll('.fp-cards--scenes .fp-card')]
        .filter((card) => !card.dataset.fpSceneBound);
      if (!cards.length) return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!canHover.matches) entry.target.classList.toggle('is-live', entry.isIntersecting);
        }),
        { rootMargin: '-38% 0px -38% 0px' }
      );
      cards.forEach((card) => {
        card.dataset.fpSceneBound = 'true';
        observer.observe(card);
      });
    };

    bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The pack pulls in when the offer has attention: hover with a mouse, or
    // on touch when the panel reaches the middle of the screen.
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const bind = () => {
      if (!('IntersectionObserver' in window)) return;
      const panels = [...document.querySelectorAll('.fp-cta__panel')].filter((panel) => !panel.dataset.fpCtaBound);
      if (!panels.length) return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (!canHover.matches) entry.target.classList.toggle('is-live', entry.isIntersecting);
        }),
        { rootMargin: '-30% 0px -30% 0px' }
      );
      panels.forEach((panel) => {
        panel.dataset.fpCtaBound = 'true';
        observer.observe(panel);
      });
    };
    bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-hiw-checklist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP = 650;

    const setup = (root) => {
      if (root.dataset.fpCheckBound) return;
      root.dataset.fpCheckBound = 'true';

      const items = [...root.querySelectorAll('.fp-hiw-check__item')];
      const count = root.querySelector('[data-fp-check-count]');
      const pct = root.querySelector('[data-fp-check-pct]');
      const status = root.querySelector('[data-fp-check-status]');
      if (!items.length) return;

      let touched = false;
      let shown = 0;
      let counter = 0;

      // Count the percentage up (or down) to its new value.
      const animateTo = (target) => {
        cancelAnimationFrame(counter);
        const from = shown;
        const start = performance.now();
        const tick = (now) => {
          const t = Math.min(1, (now - start) / 600);
          shown = Math.round(from + (target - from) * (1 - Math.pow(1 - t, 3)));
          if (pct) pct.textContent = shown;
          if (t < 1) counter = requestAnimationFrame(tick);
        };
        counter = requestAnimationFrame(tick);
      };

      const refresh = () => {
        const done = items.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
        const ratio = done / items.length;
        root.style.setProperty('--fit', ratio.toFixed(3));
        if (count) count.textContent = done;
        animateTo(Math.round(ratio * 100));
        root.classList.toggle('is-full', ratio === 1);
        if (status) status.textContent = status.dataset[ratio === 1 ? 'full' : ratio > 0 ? 'partial' : 'empty'] || '';
      };

      items.forEach((item) => {
        item.addEventListener('click', () => {
          touched = true;
          item.setAttribute('aria-pressed', item.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          refresh();
        });
      });

      // Tick everything once, in order, the first time the card is reached.
      const autoplay = () => {
        items.forEach((item, n) => {
          setTimeout(() => {
            if (touched) return;
            item.setAttribute('aria-pressed', 'true');
            refresh();
          }, 400 + n * STEP);
        });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          autoplay();
        }, { threshold: 0.45 });
        observer.observe(root.querySelector('.fp-hiw-check__card'));
      } else {
        autoplay();
      }
    };

    const init = () => document.querySelectorAll('[data-fp-hiw-check]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-hiw-delivery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.fpSortBound) return;
      root.dataset.fpSortBound = 'true';
      if (reduced.matches || !('IntersectionObserver' in window)) return;

      root.querySelectorAll('.fp-hiw-sort__lane').forEach((lane) => {
        const count = lane.querySelector('.fp-hiw-sort__count');
        let delivered = 0;
        // Every completed run of a parcel is one delivery to that destination.
        lane.querySelectorAll('.fp-hiw-sort__parcel').forEach((parcel) => {
          parcel.addEventListener('animationiteration', () => {
            delivered = delivered >= 999 ? 1 : delivered + 1;
            count.textContent = delivered;
            lane.classList.remove('is-hit');
            void lane.offsetWidth;
            lane.classList.add('is-hit');
          });
        });
      });

      // Only run the sorter while it is on screen.
      new IntersectionObserver(([entry]) => {
        root.classList.toggle('is-running', entry.isIntersecting);
      }, { threshold: 0.25 }).observe(root);
    };

    const init = () => document.querySelectorAll('[data-fp-hiw-sort]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-hiw-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (hero) => {
      if (hero.dataset.fpHiwBound) return;
      hero.dataset.fpHiwBound = 'true';

      const value = hero.querySelector('.fp-hiw-hero__counter-value');
      const count = hero.querySelector('[data-fp-hiw-count]');
      const orbit = hero.querySelector('.fp-hiw-hero__orbit');
      if (!value || !count || !orbit) return;

      let order = 1;
      hero.classList.add('is-live');
      if (reduced.matches) return;

      // Each lap of the dot is another repeat order, counted as it passes "Order".
      orbit.addEventListener('animationiteration', () => {
        order = order >= 99 ? 1 : order + 1;
        count.textContent = String(order).padStart(2, '0');
        value.classList.remove('is-bump');
        void value.offsetWidth;
        value.classList.add('is-bump');
      });
    };

    const init = () => document.querySelectorAll('[data-fp-hiw-hero]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-hiw-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.fpTlBound) return;
      root.dataset.fpTlBound = 'true';

      const list = root.querySelector('.fp-hiw-tl__list');
      const steps = [...root.querySelectorAll('.fp-hiw-tl__step')];
      if (!list || !steps.length) return;

      if (reduced.matches) {
        steps.forEach((step) => step.classList.add('is-reached'));
        return;
      }

      root.classList.add('is-armed');
      let frame = 0;

      // The fill follows a point 60% down the screen; a step is reached once
      // that point passes its node.
      const update = () => {
        frame = 0;
        const rect = list.getBoundingClientRect();
        const marker = window.innerHeight * 0.6;
        const progress = Math.min(1, Math.max(0, (marker - rect.top) / rect.height));
        root.style.setProperty('--tl-progress', progress.toFixed(4));
        steps.forEach((step) => {
          const node = step.querySelector('.fp-hiw-tl__node');
          const top = node.getBoundingClientRect().top + node.offsetHeight / 2;
          step.classList.toggle('is-reached', top <= marker);
        });
      };

      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      // Horizon scrolls .page-wrapper on desktop, not the window, so listen in capture.
      document.addEventListener('scroll', schedule, { passive: true, capture: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();
    };

    const init = () => document.querySelectorAll('[data-fp-hiw-tl]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-logo-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    const bind = () => {
      document.querySelectorAll('.fp-logos__item').forEach((item) => {
        if (item.dataset.fpTiltBound) return;
        item.dataset.fpTiltBound = 'true';
        item.addEventListener('pointermove', (event) => {
          if (!fine.matches) return;
          const rect = item.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width;
          const y = (event.clientY - rect.top) / rect.height;
          item.style.setProperty('--mx', `${x * 100}%`);
          item.style.setProperty('--my', `${y * 100}%`);
          item.style.setProperty('--ty', `${(x - 0.5) * 12}deg`);
          item.style.setProperty('--tx', `${(0.5 - y) * 12}deg`);
        });
        item.addEventListener('pointerleave', () => {
          item.style.setProperty('--tx', '0deg');
          item.style.setProperty('--ty', '0deg');
        });
      });
    };
    bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-media-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP = 2800;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (feature) => {
      if (feature.dataset.fpBrandBound) return;
      feature.dataset.fpBrandBound = 'true';

      const list = feature.querySelector('.fp-feature__list');
      const media = feature.querySelector('.fp-feature__media');
      const chip = feature.querySelector('.fp-feature__brand-chip');
      const label = chip?.querySelector('[data-fp-brand-label]');
      const items = list ? [...list.querySelectorAll('.fp-feature__item')] : [];
      if (!items.length || !media || !label) return;

      let index = -1;
      let timer = 0;
      let paused = false;
      let inView = false;
      let started = false;

      const replay = (node, className) => {
        node.classList.remove(className);
        void node.offsetWidth;
        node.classList.add(className);
      };

      const activate = (next) => {
        index = next;
        items.forEach((item, n) => item.classList.toggle('is-active', n === next));
        label.textContent = items[next].dataset.fpBrandLabel || '';
        if (!reduced.matches) {
          replay(media, 'is-scanning');
          replay(chip, 'is-swapping');
        }
      };

      const cycle = () => {
        clearTimeout(timer);
        if (paused || !inView || reduced.matches) return;
        activate((index + 1) % items.length);
        timer = setTimeout(cycle, STEP);
      };

      items.forEach((item, n) => {
        item.addEventListener('pointerenter', () => {
          if (!started) return;
          paused = true;
          clearTimeout(timer);
          if (index !== n) activate(n);
        });
        item.addEventListener('pointerleave', () => {
          paused = false;
          clearTimeout(timer);
          timer = setTimeout(cycle, STEP);
        });
      });

      // Begin only once the type-out has finished (it drops is-type-ready).
      const begin = () => {
        if (started || list.classList.contains('is-type-ready')) return;
        const typingOn = document.documentElement.classList.contains('fp-motion-enabled');
        const titles = [...list.querySelectorAll('.fp-feature__item-title')];
        if (typingOn && !titles.every((title) => title.classList.contains('is-typed'))) return;
        started = true;
        list.classList.add('is-cycling');
        if (inView) timer = setTimeout(cycle, 600);
      };

      new MutationObserver(begin).observe(list, { attributes: true, attributeFilter: ['class'] });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          clearTimeout(timer);
          if (!inView) return;
          if (started && !paused) timer = setTimeout(cycle, 600);
          else setTimeout(begin, 400);
        }, { threshold: 0.3 }).observe(feature);
      }
    };

    const init = () => document.querySelectorAll('.fp-feature--branding-motion').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 4800;
    const HOLD = 1800;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (journey) => {
      if (journey.dataset.fpJourneyBound) return;
      journey.dataset.fpJourneyBound = 'true';

      const steps = [...journey.querySelectorAll('.fp-journey__step')];
      // Without motion (or in the editor) every step stays in its finished state.
      if (steps.length < 2 || reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;

      let index = -1;
      let timer = 0;
      let paused = false;
      let inView = false;

      journey.style.setProperty('--fp-journey-duration', `${DURATION}ms`);

      const show = (next) => {
        index = next;
        steps.forEach((step, n) => {
          step.classList.toggle('is-active', n === next);
          step.classList.toggle('is-done', n < next);
        });
      };

      const advance = () => {
        clearTimeout(timer);
        if (paused || !inView) return;
        if (index >= steps.length - 1) {
          show(steps.length);
          timer = setTimeout(() => {
            show(-1);
            timer = setTimeout(advance, 700);
          }, HOLD);
          return;
        }
        show(index + 1);
        timer = setTimeout(advance, DURATION);
      };

      // Snap a step back to its resting state with no transitions, so the next
      // show() plays its scene from the start even if it had already finished.
      const replay = (n) => {
        const step = steps[n];
        step.classList.add('is-resetting');
        step.classList.remove('is-active', 'is-done');
        void step.offsetWidth;
        step.classList.remove('is-resetting');
        show(n);
      };

      const hold = (n) => {
        paused = true;
        clearTimeout(timer);
        journey.classList.add('is-paused');
        replay(n);
      };

      const release = () => {
        paused = false;
        journey.classList.remove('is-paused');
        clearTimeout(timer);
        timer = setTimeout(advance, DURATION / 2);
      };

      steps.forEach((step, n) => {
        step.addEventListener('pointerenter', (event) => event.pointerType === 'mouse' && hold(n));
        step.addEventListener('pointerleave', (event) => event.pointerType === 'mouse' && release());
        step.addEventListener('focusin', () => hold(n));
        step.addEventListener('focusout', release);
      });

      journey.classList.add('is-running');
      show(-1);

      new IntersectionObserver(
        ([entry]) => {
          inView = entry.isIntersecting;
          clearTimeout(timer);
          if (inView && !paused) timer = setTimeout(advance, index < 0 ? 250 : DURATION / 2);
        },
        { threshold: 0.35 }
      ).observe(journey);
    };

    const init = (root) => root.querySelectorAll('[data-fp-journey]').forEach(setup);
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-solution-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.fpIndexBound) return;
      root.dataset.fpIndexBound = 'true';

      const panels = [...root.querySelectorAll('.fp-sol-index__panel')];
      const links = [...root.querySelectorAll('[data-fp-sol-link]')];
      if (!panels.length || !('IntersectionObserver' in window)) {
        panels.forEach((panel) => panel.classList.add('is-seen'));
        return;
      }

      root.classList.add('is-armed');

      const setCurrent = (id) => {
        panels.forEach((panel) => panel.classList.toggle('is-current', panel.id === id));
        links.forEach((link) => link.classList.toggle('is-active', link.dataset.fpSolLink === id));
      };

      // Contents check in once, the first time a panel is properly on screen.
      const seen = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-seen');
          seen.unobserve(entry.target);
        });
      }, { threshold: 0.35 });

      // The panel crossing the middle band of the screen is the current one.
      const current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => entry.isIntersecting && setCurrent(entry.target.id));
      }, { rootMargin: '-45% 0px -45% 0px' });

      panels.forEach((panel) => {
        seen.observe(panel);
        current.observe(panel);
      });
    };

    const init = () => document.querySelectorAll('[data-fp-sol-index]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-solutions-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 4600;
    const SWAP = 480;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Where each card lands in the fan above the box, by how many there are.
    const layout = (count, width) => {
      const spread = Math.min(170, width * 0.3);
      const rows = {
        1: [[0, -150, 0]],
        2: [[-0.55, -150, -5], [0.55, -165, 5]],
        3: [[-1, -120, -8], [0, -175, 0], [1, -120, 8]],
        4: [[-1.25, -92, -9], [-0.56, -178, -3], [0.56, -186, 3], [1.25, -100, 9]],
      };
      return (rows[count] || rows[4]).map(([x, y, r]) => [x * spread, y, r]);
    };

    const setup = (hero) => {
      if (hero.dataset.fpSolBound) return;
      hero.dataset.fpSolBound = 'true';

      const fans = [...hero.querySelectorAll('.fp-sol-hero__fan')];
      const tabs = [...hero.querySelectorAll('.fp-sol-hero__tab')];
      const captions = [...hero.querySelectorAll('.fp-sol-hero__caption-item')];
      const segs = [...hero.querySelectorAll('.fp-sol-hero__seg')];
      const counter = hero.querySelector('[data-fp-sol-index]');
      const scene = hero.querySelector('.fp-sol-hero__scene');
      if (!fans.length || !scene) return;

      let index = 0;
      let timer = 0;
      let swapTimer = 0;
      let inView = false;
      let paused = false;

      hero.style.setProperty('--sol-duration', `${DURATION}ms`);

      const place = () => {
        const width = scene.clientWidth;
        fans.forEach((fan) => {
          const cards = [...fan.querySelectorAll('.fp-sol-hero__card')];
          layout(cards.length, width).forEach(([x, y, r], n) => {
            if (!cards[n]) return;
            cards[n].style.setProperty('--x', `${x}px`);
            cards[n].style.setProperty('--y', `${y}px`);
            cards[n].style.setProperty('--r', `${r}deg`);
          });
        });
      };

      const mark = (next) => {
        index = next;
        fans.forEach((fan, n) => fan.classList.toggle('is-active', n === next));
        captions.forEach((caption, n) => caption.classList.toggle('is-active', n === next));
        tabs.forEach((tab, n) => {
          tab.classList.toggle('is-active', n === next);
          tab.setAttribute('aria-pressed', n === next ? 'true' : 'false');
        });
        segs.forEach((seg, n) => {
          seg.classList.toggle('is-done', n < next);
          seg.classList.remove('is-active');
        });
        if (counter) counter.textContent = String(next + 1).padStart(2, '0');
      };

      const show = (next) => {
        clearTimeout(swapTimer);
        if (reduced.matches) {
          mark(next);
          hero.classList.add('is-open');
          return;
        }
        // Pack away the current contents, then unpack the next solution.
        hero.classList.remove('is-open');
        swapTimer = setTimeout(() => {
          mark(next);
          void hero.offsetWidth;
          hero.classList.add('is-open');
          if (segs[next]) segs[next].classList.add('is-active');
        }, hero.dataset.fpSolStarted ? SWAP : 60);
        hero.dataset.fpSolStarted = 'true';
      };

      const advance = () => {
        clearTimeout(timer);
        if (!inView || paused || reduced.matches) return;
        timer = setTimeout(() => {
          show((index + 1) % fans.length);
          advance();
        }, DURATION);
      };

      tabs.forEach((tab, n) => {
        tab.addEventListener('click', () => {
          paused = true;
          hero.classList.add('is-paused');
          clearTimeout(timer);
          show(n);
          // Resume the tour after the visitor has had time to look.
          clearTimeout(tab._resume);
          tab._resume = setTimeout(() => {
            paused = false;
            hero.classList.remove('is-paused');
            advance();
          }, 9000);
        });
      });

      place();
      window.addEventListener('resize', place, { passive: true });

      if ('IntersectionObserver' in window && !reduced.matches) {
        new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          if (inView && !hero.dataset.fpSolStarted) show(0);
          if (inView) advance();
          else clearTimeout(timer);
        }, { threshold: 0.35 }).observe(scene);
      } else {
        show(0);
      }
    };

    const init = () => document.querySelectorAll('[data-fp-sol-hero]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-tech-api"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setup = (root) => {
      if (root.dataset.fpApiBound) return;
      root.dataset.fpApiBound = 'true';
      if (reduced.matches || !('IntersectionObserver' in window)) return;

      const nodes = [...root.querySelectorAll('.fp-api__node')];
      // An update landing at a system lights that system briefly.
      root.querySelectorAll('.fp-api__packet--out').forEach((packet, i) => {
        packet.addEventListener('animationiteration', () => {
          const node = nodes[i];
          if (!node) return;
          node.classList.add('is-hit');
          setTimeout(() => node.classList.remove('is-hit'), 700);
        });
      });

      new IntersectionObserver(([entry]) => {
        root.classList.toggle('is-running', entry.isIntersecting);
      }, { threshold: 0.25 }).observe(root);
    };
    const init = () => document.querySelectorAll('[data-fp-api]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-tech-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Example calls shown in the console. [text, class] pairs; '\n' breaks lines.
    const SCRIPTS = [
      [
        ['$ ', 'm'], ['POST', 'k'], [' /v1/orders\n', ''],
        ['{\n  ', ''], ['"account"', 'n'], [': ', ''], ['"FP-2041"', 's'], [',\n  ', ''],
        ['"vehicles"', 'n'], [': ', ''], ['12', 'k'], [',\n  ', ''],
        ['"pack"', 'n'], [': ', ''], ['"agreed-spec"', 's'], ['\n}\n\n', ''],
        ['← 201 Created\n', 'ok'],
        ['{ ', ''], ['"order"', 'n'], [': ', ''], ['"FP-10432"', 's'], [', ', ''], ['"status"', 'n'], [': ', ''], ['"confirmed"', 's'], [' }', ''],
      ],
      [
        ['$ ', 'm'], ['GET', 'k'], [' /v1/orders/FP-10432\n\n', ''],
        ['← 200 OK\n', 'ok'],
        ['{\n  ', ''], ['"status"', 'n'], [': ', ''], ['"packing"', 's'], [',\n  ', ''],
        ['"packed"', 'n'], [': ', ''], ['8', 'k'], [',\n  ', ''],
        ['"of"', 'n'], [': ', ''], ['12', 'k'], [',\n  ', ''],
        ['"branded"', 'n'], [': ', ''], ['true', 'k'], ['\n}', ''],
      ],
      [
        ['# update sent to your systems\n', 'm'],
        ['→ ', 'k'], ['order.dispatched\n\n', ''],
        ['{\n  ', ''], ['"order"', 'n'], [': ', ''], ['"FP-10432"', 's'], [',\n  ', ''],
        ['"destinations"', 'n'], [': ', ''], ['3', 'k'], [',\n  ', ''],
        ['"vehicles"', 'n'], [': ', ''], ['12', 'k'], ['\n}\n\n', ''],
        ['✓ delivered to every address', 'ok'],
      ],
    ];

    const escape = (text) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;');

    const setup = (root) => {
      if (root.dataset.fpTechBound) return;
      root.dataset.fpTechBound = 'true';

      const code = root.querySelector('[data-fp-tech-code]');
      const steps = [...root.querySelectorAll('.fp-tech-hero__step')];
      const ms = root.querySelector('[data-fp-tech-ms]');
      if (!code) return;

      const render = (script, chars) => {
        let left = chars;
        let html = '';
        for (const [text, cls] of script) {
          if (left <= 0) break;
          const part = text.slice(0, left);
          left -= part.length;
          html += cls ? `<span class="${cls}">${escape(part)}</span>` : escape(part);
        }
        code.innerHTML = html;
      };

      const length = (script) => script.reduce((sum, [text]) => sum + text.length, 0);

      if (reduced.matches) {
        render(SCRIPTS[0], length(SCRIPTS[0]));
        return;
      }

      let index = 0;
      let timer = 0;
      let visible = true;

      const play = () => {
        clearTimeout(timer);
        if (!visible) return;
        const script = SCRIPTS[index];
        const total = length(script);
        steps.forEach((step, n) => step.classList.toggle('is-active', n === index));
        if (ms) ms.textContent = 28 + Math.floor(Math.random() * 30);
        let chars = 0;
        const type = () => {
          chars += 2;
          render(script, chars);
          if (chars < total) timer = setTimeout(type, 22);
          else timer = setTimeout(() => { index = (index + 1) % SCRIPTS.length; play(); }, 2600);
        };
        type();
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const was = visible;
          visible = entry.isIntersecting;
          if (visible && !was) play();
          if (!visible) clearTimeout(timer);
        }, { threshold: 0.2 }).observe(root);
        visible = false;
      } else {
        play();
      }
    };

    const init = () => document.querySelectorAll('[data-fp-tech-hero]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-tech-speed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.fpSpeedBound) return;
      root.dataset.fpSpeedBound = 'true';

      const slow = root.querySelector('.fp-speed__lane--slow .fp-speed__track');
      const fast = root.querySelector('.fp-speed__lane--fast .fp-speed__track');
      const counters = [...root.querySelectorAll('[data-fp-count]')];
      if (!slow || !fast) return;

      const set = (track, p) => track.style.setProperty('--p', p.toFixed(4));

      if (reduced.matches || !('IntersectionObserver' in window)) {
        set(slow, 0.3);
        set(fast, 1);
        root.classList.add('is-done', 'is-waiting');
        return;
      }

      // One race: the platform lane runs straight through; the usual lane
      // creeps, then stalls waiting on email. Then both reset and go again.
      const RACE = 6200;
      const FAST = 1500;
      let frame = 0;
      let start = 0;
      let running = false;

      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const slowAt = (t) => {
        if (t < 0.18) return ease(t / 0.18) * 0.2;
        if (t < 0.45) return 0.2;
        if (t < 0.62) return 0.2 + ease((t - 0.45) / 0.17) * 0.18;
        return 0.38;
      };

      const tick = (now) => {
        if (!running) return;
        if (!start) start = now;
        const elapsed = now - start;
        const t = Math.min(1, elapsed / RACE);
        set(fast, ease(Math.min(1, elapsed / FAST)));
        set(slow, slowAt(t));
        root.classList.toggle('is-done', elapsed > FAST);
        root.classList.toggle('is-waiting', (t > 0.18 && t < 0.45) || t > 0.62);
        if (t >= 1) {
          start = 0;
          root.classList.remove('is-done', 'is-waiting');
          set(fast, 0);
          set(slow, 0);
          setTimeout(() => { if (running) frame = requestAnimationFrame(tick); }, 700);
          return;
        }
        frame = requestAnimationFrame(tick);
      };

      // Headline figures count up once.
      const countUp = () => {
        counters.forEach((node) => {
          const target = parseFloat(node.dataset.fpCount);
          if (Number.isNaN(target)) return;
          const decimals = (node.dataset.fpCount.split('.')[1] || '').length;
          const begin = performance.now();
          const step = (now) => {
            const t = Math.min(1, (now - begin) / 1400);
            node.textContent = (target * ease(t)).toFixed(decimals);
            if (t < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      };

      let counted = false;
      new IntersectionObserver(([entry]) => {
        running = entry.isIntersecting;
        if (running) {
          start = 0;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(tick);
          if (!counted) { counted = true; countUp(); }
        }
      }, { threshold: 0.3 }).observe(root);
    };

    const init = () => document.querySelectorAll('[data-fp-speed]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-tech-stack"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP = 4500;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.fpStackBound) return;
      root.dataset.fpStackBound = 'true';

      const layers = [...root.querySelectorAll('.fp-stack__layer')].sort((a, b) => a.dataset.layer - b.dataset.layer);
      const tabs = [...root.querySelectorAll('.fp-stack__tab')];
      const panels = [...root.querySelectorAll('.fp-stack__panel')];
      const art = root.querySelector('.fp-stack__art');
      if (!tabs.length) return;

      let index = 0;
      let timer = 0;
      let held = false;
      let inView = false;

      const show = (n) => {
        index = n;
        layers.forEach((layer, i) => layer.classList.toggle('is-active', i === n));
        panels.forEach((panel, i) => panel.classList.toggle('is-active', i === n));
        tabs.forEach((tab, i) => {
          tab.classList.toggle('is-active', i === n);
          tab.setAttribute('aria-pressed', i === n ? 'true' : 'false');
        });
      };

      const cycle = () => {
        clearTimeout(timer);
        if (held || !inView || reduced.matches) return;
        timer = setTimeout(() => { show((index + 1) % tabs.length); cycle(); }, STEP);
      };

      const hold = (n) => {
        held = true;
        clearTimeout(timer);
        show(n);
      };

      const release = () => {
        held = false;
        cycle();
      };

      tabs.forEach((tab, n) => tab.addEventListener('click', () => hold(n)));
      layers.forEach((layer, n) => {
        layer.addEventListener('pointerenter', () => hold(n));
        layer.addEventListener('pointerleave', release);
        layer.addEventListener('click', () => hold(n));
      });
      root.querySelector('.fp-stack__detail')?.addEventListener('pointerleave', () => { if (held) release(); });

      show(0);

      if (!reduced.matches && 'IntersectionObserver' in window) {
        // The stack drops into place, one layer after another, the first time.
        if (art) {
          art.classList.add('is-assembling');
          layers.forEach((layer, i) => { layer.style.transitionDelay = `${(layers.length - 1 - i) * 140}ms`; });
        }
        new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          if (inView && art?.classList.contains('is-assembling')) {
            art.classList.remove('is-assembling');
            setTimeout(() => layers.forEach((layer) => { layer.style.transitionDelay = ''; }), 1200);
          }
          if (inView) cycle();
          else clearTimeout(timer);
        }, { threshold: 0.3 }).observe(root);
      }
    };

    const init = () => document.querySelectorAll('[data-fp-stack]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-video-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (reel) => {
      if (reel.dataset.fpReelBound) return;
      reel.dataset.fpReelBound = 'true';

      const tiles = [...reel.querySelectorAll('.fp-reel__tile')];
      if (!('IntersectionObserver' in window)) {
        tiles.forEach((tile) => tile.classList.add('is-in'));
        return;
      }
      reel.classList.add('is-armed');

      const arrive = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          arrive.unobserve(entry.target);
        });
      }, { threshold: 0.2 });

      tiles.forEach((tile) => {
        arrive.observe(tile);

        const frame = tile.querySelector('.fp-reel__frame');

        frame.addEventListener('pointermove', (event) => {
          const rect = frame.getBoundingClientRect();
          frame.style.setProperty('--mx', `${event.clientX - rect.left}px`);
          frame.style.setProperty('--my', `${event.clientY - rect.top}px`);
        });

      });
    };

    const init = () => document.querySelectorAll('[data-fp-reel]').forEach(setup);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
